var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRehab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_2303)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_2303)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_80_2303)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_2303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0.219727H0V50.2197H50V0.219727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_2303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8221 36.1667C12.8221 39.7307 15.7216 42.6304 19.2856 42.6304C20.0129 42.6304 20.6025 43.2201 20.6025 43.9473C20.6025 44.6744 20.0129 45.2641 19.2856 45.2641C14.2693 45.2641 10.1883 41.1831 10.1883 36.1667C10.1883 35.4396 10.7779 34.8499 11.5052 34.8499C12.2325 34.8499 12.8221 35.4394 12.8221 36.1667ZM44.5847 48.2345L35.8784 33.44C35.6418 33.038 35.2101 32.791 34.7435 32.791H20.6023V19.4418C20.6023 18.7146 20.0128 18.1249 19.2855 18.1249C18.5581 18.1249 17.9686 18.7146 17.9686 19.4418V34.1079C17.9686 34.8351 18.5581 35.4248 19.2855 35.4248H33.9904L42.3149 49.5705C42.5603 49.9875 42.9997 50.2197 43.4512 50.2197C43.678 50.2197 43.9081 50.161 44.1179 50.0374C44.7446 49.6686 44.9537 48.8615 44.5847 48.2345ZM11.7605 7.78798C11.7605 3.61478 15.1556 0.219727 19.3285 0.219727C23.5017 0.219727 26.897 3.61478 26.897 7.78798C26.897 11.9611 23.5019 15.3562 19.3285 15.3562C15.1556 15.3561 11.7605 11.961 11.7605 7.78798ZM14.3943 7.78798C14.3943 10.5088 16.6077 12.7224 19.3284 12.7224C22.0495 12.7224 24.2631 10.5088 24.2631 7.78798C24.2631 5.06717 22.0495 2.85349 19.3285 2.85349C16.6078 2.85349 14.3943 5.06717 14.3943 7.78798ZM31.69 39.3544C31.0087 39.1022 30.2502 39.45 29.9976 40.132C28.3465 44.5902 24.0415 47.5857 19.2855 47.5857C12.9892 47.5857 7.86681 42.4633 7.86681 36.1667C7.86681 31.9949 10.1412 28.1558 13.8026 26.1475C14.4403 25.7977 14.6737 24.9973 14.3238 24.3596C13.9741 23.7219 13.1736 23.4887 12.5359 23.8384C8.03129 26.3092 5.23291 31.0331 5.23291 36.1667C5.23291 43.9154 11.5368 50.2194 19.2853 50.2194C25.1379 50.2194 30.4354 46.5332 32.4674 41.0467C32.7202 40.3647 32.3721 39.6071 31.69 39.3544Z",
    fill: "#003588"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_2303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_2303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_80_2303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehab);
export default __webpack_public_path__ + "static/media/rehab.f60fa43393a6df57a02c74f6be5349f7.svg";
export { ForwardRef as ReactComponent };